module.exports = __webpack_public_path__ + "static/screen-pushit-1-19d8c9a4386e16fa3bdd98235d4074a7.jpg";